define(["react","@bingads-webui-react/fabric-control","prop-types","@bingads-webui-react/hoc-with-signal"], function(__WEBPACK_EXTERNAL_MODULE__3__, __WEBPACK_EXTERNAL_MODULE__5__, __WEBPACK_EXTERNAL_MODULE__10__, __WEBPACK_EXTERNAL_MODULE__400__) { return /******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
/******/ 		}
/******/ 	};
/******/
/******/ 	// define __esModule on exports
/******/ 	__webpack_require__.r = function(exports) {
/******/ 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
/******/ 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
/******/ 		}
/******/ 		Object.defineProperty(exports, '__esModule', { value: true });
/******/ 	};
/******/
/******/ 	// create a fake namespace object
/******/ 	// mode & 1: value is a module id, require it
/******/ 	// mode & 2: merge all properties of value into the ns
/******/ 	// mode & 4: return value when already ns object
/******/ 	// mode & 8|1: behave like require
/******/ 	__webpack_require__.t = function(value, mode) {
/******/ 		if(mode & 1) value = __webpack_require__(value);
/******/ 		if(mode & 8) return value;
/******/ 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
/******/ 		var ns = Object.create(null);
/******/ 		__webpack_require__.r(ns);
/******/ 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
/******/ 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
/******/ 		return ns;
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 397);
/******/ })
/************************************************************************/
/******/ ({

/***/ 10:
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE__10__;

/***/ }),

/***/ 3:
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE__3__;

/***/ }),

/***/ 397:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(398);


/***/ }),

/***/ 398:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _withSignalFabric = __webpack_require__(399);

Object.keys(_withSignalFabric).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _withSignalFabric[key];
    }
  });
});

var _renderLogger = __webpack_require__(401);

Object.keys(_renderLogger).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _renderLogger[key];
    }
  });
});

/***/ }),

/***/ 399:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.IconButton = exports.Checkbox = exports.TextField = exports.Dropdown = exports.SearchBox = exports.Link = exports.ChoiceGroup = exports.DefaultButton = exports.PrimaryButton = void 0;

var _fabricControl = __webpack_require__(5);

var _hocWithSignal = __webpack_require__(400);

const PrimaryButton = (0, _hocWithSignal.withSignal)(_fabricControl.PrimaryButton, {
  onClick: _hocWithSignal.CommonEventParser
});
exports.PrimaryButton = PrimaryButton;
const DefaultButton = (0, _hocWithSignal.withSignal)(_fabricControl.DefaultButton, {
  onClick: _hocWithSignal.CommonEventParser
});
exports.DefaultButton = DefaultButton;
const ChoiceGroup = (0, _hocWithSignal.withSignal)(_fabricControl.ChoiceGroup, {
  onChange: _hocWithSignal.CommonEventParser
});
exports.ChoiceGroup = ChoiceGroup;
const Link = (0, _hocWithSignal.withSignal)(_fabricControl.Link, {
  onClick: _hocWithSignal.CommonEventParser
});
exports.Link = Link;
const SearchBox = (0, _hocWithSignal.withSignal)(_fabricControl.SearchBox, {
  onChange: _hocWithSignal.CommonEventParser
});
exports.SearchBox = SearchBox;
const Dropdown = (0, _hocWithSignal.withSignal)(_fabricControl.Dropdown, {
  onChange: _hocWithSignal.FabricDropdownParser
});
exports.Dropdown = Dropdown;
const TextField = (0, _hocWithSignal.withSignal)(_fabricControl.TextField, {
  onChange: _hocWithSignal.CommonEventParser
});
exports.TextField = TextField;
const Checkbox = (0, _hocWithSignal.withSignal)(_fabricControl.Checkbox, {
  onChange: _hocWithSignal.CommonEventParser
});
exports.Checkbox = Checkbox;
const IconButton = (0, _hocWithSignal.withSignal)(_fabricControl.IconButton, {
  onClick: _hocWithSignal.CommonEventParser
});
exports.IconButton = IconButton;

/***/ }),

/***/ 400:
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE__400__;

/***/ }),

/***/ 401:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.RenderLogger = void 0;

var _react = _interopRequireWildcard(__webpack_require__(3));

var _propTypes = _interopRequireDefault(__webpack_require__(10));

var _hocWithSignal = __webpack_require__(400);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {}; if (desc.get || desc.set) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj.default = obj; return newObj; } }

const RenderLoggerInternal = ({
  title,
  activity,
  children
}) => {
  (0, _react.useEffect)(() => {
    if (activity) {
      activity.signal(`RenderLogger - ${title} has been rendered.`);
    } // eslint-disable-next-line react-hooks/exhaustive-deps

  }, []);
  return _react.default.createElement(_react.default.Fragment, null, " ", children);
};

RenderLoggerInternal.propTypes = {
  title: _propTypes.default.string.isRequired,
  activity: _propTypes.default.shape({
    signal: _propTypes.default.func
  }),
  children: _propTypes.default.oneOfType([_propTypes.default.node, _propTypes.default.arrayOf(_propTypes.default.node)]).isRequired
};
RenderLoggerInternal.defaultProps = {
  activity: null
};
const RenderLogger = (0, _hocWithSignal.withActivityContext)(RenderLoggerInternal);
exports.RenderLogger = RenderLogger;

/***/ }),

/***/ 5:
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE__5__;

/***/ })

/******/ })});;
